/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
  return {
    text: {
      primary: theme.darkBlack,
      secondary: theme.black,
      tertiary: theme.gray,
    },
    primary: {
      main: theme.darkBlack,
      secondary: theme.lightBlack,
      tertiary: theme.darkGray,
    },
    form: {
      primary: theme.darkBlack,
      // secondary: theme.lightBlack,
      hover: theme.lightBlack,
    },
    menu: {
      main: theme.darkBlack,
      secondary: theme.lightBlack,
      selected: theme.red,
      // unselected: theme.lightGray,
    },
    drawer: {
      // main: theme.darkBackgroundText,
      secondary: theme.darkGray,
      selected: theme.darkGray,
      unselected: 'white',
    },
    toolbar: {
      // main: theme.dark,
      secondary: theme.lightGray,
      unselected: theme.lightBlack,
      selected: theme.darkBlack,
    },
    toggleBtn: {
      selected: theme.lightBlack,
    },
  };
}
